export default __webpack_public_path__ + "static/media/delete-row.42957823.svg";